import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from "./ClientMenu.module.css";
import MenuCard from "@/ui/components/client/MenuCard/MenuCard";
import backBtnNew from '@/ui/assets/icons/backBtnNew.svg';
import cartaMilkshakeIcon from '@/ui/assets/icons/cartaMilkshakeIcon.svg';

const ClientMenu = () => {
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate(-1);
    };

    return (
        <main className={styles.clientMenu}>
            <header className={styles.header}>
                <div className={styles.headerTop}>
                    <button className={styles.backButton} type="button" aria-label="Volver" onClick={handleGoBack}>
                        <img src={backBtnNew} alt="Volver" />
                    </button>

                    <h1 className={styles.title}>Nuestra carta</h1>
                </div>

                <div className={styles.separator}>
                    <span className={styles.separatorLine}></span>

                    <img src={cartaMilkshakeIcon} alt="" className={styles.separatorIcon} />

                    <span className={styles.separatorLine}></span>
                </div>

                <p className={styles.description}>
                    Conoce todos nuestros productos y precios
                </p>
            </header>

            <section className={styles.content}>
                <MenuCard />
            </section>
        </main>
    );
};

export default ClientMenu;